'use client';
import { ThemeOptions, alpha } from '@mui/material';

export const sidebarTheme: ThemeOptions = {
  type: 'semi-dark',
  palette: {
    primary: {
      main: '#3DABE6',
      light: '#A67FFB',
      dark: '#5E3BB7',
      contrastText: '#FFF',
    },
    secondary: {
      main: '#E44A77',
      light: '#FF7EA6',
      dark: '#DF295E',
      contrastText: '#FFF',
    },
    error: {
      main: '#E73145',
      light: '#FF6A70',
      dark: '#AD001E',
      contrastText: '#FFF',
    },
    warning: {
      main: '#F39711',
      light: '#FFC84C',
      dark: '#BB6900',
      contrastText: '#FFF',
    },
    info: {
      main: '#2EB5C9',
      light: '#6FE7FC',
      dark: '#008598',
      contrastText: '#FFF',
    },
    success: {
      main: '#3BD2A2',
      light: '#78FFD3',
      dark: '#00A073',
      contrastText: '#FFF',
    },
    text: {
      primary: '#475259',
      secondary: '#8595A6',
      disabled: '#A2B2C3',
    },
    divider: '#DEE2E6',
    background: {
      paper: '#FFFFFF',
      default: '#F5F7FA',
    },
    action: {
      active: '#475259',
      hover: '#F5F7FA',
    },
  },
  jumboComponents: {
    JumboNavbar: {
      nav: {
        action: {
          active: '#3DABE6',
          hover: '#3DABE6',
        },
        background: {
          active: alpha('#3DABE6', 0.15),
          hover: '#E9ECEF',
        },
        tick: {
          active: '#3DABE6',
          hover: '#ADB5BD',
        },
      },
    },
  },
};
